"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetsSensitiveTopicExclusionsTopicsInnerToJSON = exports.TargetsSensitiveTopicExclusionsTopicsInnerFromJSONTyped = exports.TargetsSensitiveTopicExclusionsTopicsInnerFromJSON = exports.instanceOfTargetsSensitiveTopicExclusionsTopicsInner = void 0;
var SensitiveTopicFilter_1 = require("./SensitiveTopicFilter");
/**
 * Check if a given object implements the TargetsSensitiveTopicExclusionsTopicsInner interface.
 */
function instanceOfTargetsSensitiveTopicExclusionsTopicsInner(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "filterOption" in value;
    return isInstance;
}
exports.instanceOfTargetsSensitiveTopicExclusionsTopicsInner = instanceOfTargetsSensitiveTopicExclusionsTopicsInner;
function TargetsSensitiveTopicExclusionsTopicsInnerFromJSON(json) {
    return TargetsSensitiveTopicExclusionsTopicsInnerFromJSONTyped(json, false);
}
exports.TargetsSensitiveTopicExclusionsTopicsInnerFromJSON = TargetsSensitiveTopicExclusionsTopicsInnerFromJSON;
function TargetsSensitiveTopicExclusionsTopicsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'filterOption': (0, SensitiveTopicFilter_1.SensitiveTopicFilterFromJSON)(json['filter_option']),
    };
}
exports.TargetsSensitiveTopicExclusionsTopicsInnerFromJSONTyped = TargetsSensitiveTopicExclusionsTopicsInnerFromJSONTyped;
function TargetsSensitiveTopicExclusionsTopicsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'filter_option': (0, SensitiveTopicFilter_1.SensitiveTopicFilterToJSON)(value.filterOption),
    };
}
exports.TargetsSensitiveTopicExclusionsTopicsInnerToJSON = TargetsSensitiveTopicExclusionsTopicsInnerToJSON;
